import TextArea from "antd/es/input/TextArea";
import PropTypes from "prop-types";
import FormItem from "antd/es/form/FormItem";
import { Form } from "antd";

StudyRemarkModal.propTypes = {
  remarksData: PropTypes.array,
};

function StudyRemarkModal({ remarksData }) {
  // console.log("remarksData", remarksData);
  return (
    <>
      <div
        style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "10px" }}
      >
        {remarksData?.GradeAssigned?.data?.map((element) => {
          return (
            element?.remark &&
            element?.remark.trim() != "" && (
              <div className="mb-1" key={element?.id}>
                <div className="add_descriptions">
                  <b className="mx-1">
                    QC <b>{element?.["gradeQualityChecker.name"]}</b> gave
                    remark to
                  </b>
                  <span className="mx-1">-</span>

                  <b style={{ fontSize: "16px" }}>
                    Dr. {element?.["gradeRadiologist.name"]}
                  </b>
                </div>

                <div className="d-flex edit_descrption_textarea">
                  <div style={{ width: "500px" }}>
                    <Form>
                      <FormItem>
                        <TextArea
                          autoSize={{ minRows: 2, maxRows: 8 }}
                          value={element?.remark}
                        />
                      </FormItem>
                    </Form>
                  </div>
                </div>
              </div>
            )
          );
        })}
      </div>
    </>
  );
}

export default StudyRemarkModal;
